import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/**
 * Tracks which evidence IDs currently have in-progress annotation jobs.
 * Populated by useAnnotationJobPoller in App.tsx.
 * Any component can read `state.annotationPolling.processingEvidenceIds` to show a loading indicator.
 */
interface AnnotationPollingState {
  processingEvidenceIds: string[]
  pendingJobCountByEvidenceId: Record<string, number>
  isPollingActive: boolean
}

const initialState: AnnotationPollingState = {
  processingEvidenceIds: [],
  pendingJobCountByEvidenceId: {},
  isPollingActive: false,
}

const annotationPollingSlice = createSlice({
  name: 'annotationPolling',
  initialState,
  reducers: {
    setProcessingEvidenceIds(state, action: PayloadAction<string[]>) {
      state.processingEvidenceIds = action.payload
    },
    removeProcessingEvidenceId(state, action: PayloadAction<string>) {
      state.processingEvidenceIds = state.processingEvidenceIds.filter(
        (id) => id !== action.payload,
      )
      delete state.pendingJobCountByEvidenceId[action.payload]
    },
    setPendingJobCountByEvidenceId(state, action: PayloadAction<Record<string, number>>) {
      state.pendingJobCountByEvidenceId = action.payload
    },
    activatePolling(state) {
      state.isPollingActive = true
    },
    deactivatePolling(state) {
      state.isPollingActive = false
    },
  },
})

export const {
  setProcessingEvidenceIds,
  removeProcessingEvidenceId,
  setPendingJobCountByEvidenceId,
  activatePolling,
  deactivatePolling,
} = annotationPollingSlice.actions
export default annotationPollingSlice.reducer
